export default __webpack_public_path__ + "static/media/partner-7.d4694046.png";